import React from 'react'
import AppDialog from 'components/AppDialog'
import { default as AppMessage } from 'components/AppMessage'
import { message, Icon } from 'antd'
import api, { AppModule, AppAction as AppActions } from 'api'
import { AppTable } from 'components/AppTable'
import { AppInput } from 'components/AppFormItem'
import AppTableAction from 'components/AppAction/AppTableAction'

interface Props {
	mode: number
	afterSave?: () => void
	appModule: AppModule
}
// 二级模块
export default class ModuleEdit extends React.Component<Props> {
	state = { dataSource: [] as AppActions[] }
	// componentDidMount = async () => {
	// 	let dataSource = this.props.appModule.appActionList
	// 	if (dataSource != null) {
	// 		this.setState({ dataSource })
	// 		this.refreshTable(dataSource)
	// 	}
	// }
	// 保存
	saveFormData = async () => {
		let appModule: AppModule = {} // this.refForm.current.getData()
		if (this.props.mode === 2) {
			let appActionList: AppActions[] = this.refTable.current.getGridData()
			appModule.appActionList = appActionList
		}
		if (!appModule) return
		let res = await api.modeling.module.saveModule(appModule)
		if (!res.result) {
			AppMessage.alark(res.msg)
			return
		} else {
			message.success('操作成功!')
			this.props.afterSave && this.props.afterSave()
		}
		AppDialog.close()
	}

	close = () => {
		AppDialog.close()
	}
	// 添加权限点
	addAction = async () => {
		let { appModule } = this.props
		let idsj = -new Date().getTime()
		let { dataSource } = this.state
		let appAction: AppActions = {
			actionCode: '',
			application: appModule.application,
			code: '',
			moduleId: 0,
			name: '',
			parentCode: appModule.parentCode,
			id: idsj,
		}
		dataSource.push(appAction)
		this.refreshTable(dataSource)
		this.setState({ dataSource })
	}
	// 删除权限点
	deleteAction = async (appAction: AppActions) => {
		let res = await AppMessage.confirm('您确定要删除该记录吗？', true)
		if (res) {
			let { dataSource } = this.state
			dataSource = dataSource.filter(e => e.id !== appAction.id)
			this.setState({ dataSource })
			this.refreshTable(dataSource)
		}
	}
	editActionCode = (appAction: AppActions, e: any, fullCode: any) => {
		let { dataSource } = this.state
		dataSource.filter(a => {
			if (a.id === appAction.id) {
				;(a.code = e), (a.actionCode = fullCode + e)
			}
		})
		this.setState(dataSource)
	}
	editActionList = (formData: AppModule) => {
		let dataSource = this.state.dataSource
		return this.props.mode === 2 ? (
			<AppTable dataSource={dataSource} ref={this.refTable} data={dataSource} paging={false}>
				<AppTable.ColIndex title="序号" />
				<AppTable.ColEdit
					title="权限点编号"
					field="actionCode"
					width={280}
					render={(data: AppActions) => {
						return (
							<AppInput
								placeholder="请输入2位编码, 例如: 01"
								value={data.code}
								prefix={formData.fullCode}
								onChange={e => this.editActionCode(data, e, formData.fullCode)}
							/>
						)
					}}
				/>
				<AppTable.ColEdit title="权限点名称" field="name" />
				<AppTable.ColAction
					render={(data: AppActions) => {
						return (
							<React.Fragment>
								<AppTableAction
									onClick={() => {
										this.deleteAction(data)
									}}
									label="删除"
								/>
							</React.Fragment>
						)
					}}
				/>
			</AppTable>
		) : (
			''
		)
	}
	refreshTable = (dataSource: any[]) => {
		this.refTable && this.refTable.current && this.refTable.current.fetchDataSource(dataSource)
	}
	refTable = React.createRef<AppTable>()
	render() {
		let formData = { ...this.props.appModule }
		let { mode } = this.props
		return (
			<div className="app-dialog-form-container">
				{/* <div className="app-dialog-form">
          <AppForm
            formStyle={{ width: '100%' }}
            ref={this.refForm}
            defaultData={formData}
            labelWidth={100}
          >
            <AppInput
              label="模块名称"
              field="name"
              placeholder="请输入模块名称"
              value = {formData.name}
              req
            />
            <AppInput
              label="应用编码"
              value = {formData.code}
              field="code"
              placeholder="请输入2位编码, 例如: 01"
              headerDescrip = {formData.parentCode}
              disabled={this.props.mode===2 ? true : false}
              req
            />
          <AppInput
             label="排序编码"
             value = {formData.sort}
              field="sort"
              placeholder="建议与应用编码一致,例如：000101"
              req
            />
          </AppForm>
          {mode === 2 ?
          <div >
            <span>权限点</span>
            <span onClick={()=>{this.addAction()}}>
              <Icon type="plus-circle" theme="twoTone" />新增
            </span>
          </div>: ""}
          {this.editActionList(formData)}
        </div>
        <AppFormMenu>
          <AppAction title="取消" type="default" action={() => this.close()} />
          <AppAction
            title="确定"
            type="primary"
            action={() => this.saveFormData()}
          />
        </AppFormMenu> */}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/module/ModuleEdit.tsx